import { useEffect, useState } from "react";
import { useEnv } from "helpers/useEnv";
import { datadogRum } from "@datadog/browser-rum";
import { IUser } from "modules/app/types";
import { initUser } from "../../helpers/initUser";
import { config } from "../../config";
import useTrackRefreshes from "../useTrackRefreshes";
import useTrackCompanyPlan from "../useTrackCompanyPlan";
import useTrackEventCode from "../useTrackEventCode";
import useTrackIframe from "../useTrackIframe";
import useTrackEventRole from "../useTrackEventRole";
import useTrackCompanyRole from "../useTrackCompanyRole";

export const useMonitoring = (user?: IUser): void => {
  const { isDevEnv } = useEnv();

  const [isInit, setInit] = useState(
    Boolean(datadogRum.getInternalContext()?.session_id),
  );

  useEffect(() => {
    if (isInit || isDevEnv || !user) {
      return;
    }

    datadogRum.init(config);
    datadogRum.startSessionReplayRecording();

    initUser(user);

    setInit(true);
  }, [user, isDevEnv, isInit]);

  useTrackCompanyPlan(isInit);
  useTrackIframe(isInit);
  useTrackEventCode(isInit);
  useTrackRefreshes(isInit);
  useTrackEventRole(isInit);
  useTrackCompanyRole(isInit);
};
